/** Read-only sign-in method labels for the account settings section. */
import { isPasswordAuthUser } from '@/services/authEmailVerification';

const GOOGLE_PROVIDER_ID = 'google.com';

/**
 * @param {import('firebase/auth').User | null | undefined} user
 * @returns {'google' | 'password' | 'unknown' | 'anonymous'}
 */
export function resolveAccountSignInMethod(user) {
  if (!user || user.isAnonymous) {
    return 'anonymous';
  }
  const hasGoogle =
    user.providerData?.some((p) => p.providerId === GOOGLE_PROVIDER_ID) ?? false;
  if (hasGoogle) {
    return 'google';
  }
  if (isPasswordAuthUser(user)) {
    return 'password';
  }
  return 'unknown';
}

/**
 * @param {import('firebase/auth').User | null | undefined} user
 * @returns {boolean}
 */
export function isAccountEmailVerified(user) {
  if (!user || user.isAnonymous) {
    return false;
  }
  return user.emailVerified === true;
}
